module.exports = __webpack_public_path__ + "static/img/ilustra_verso_cin.53a07c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dicas-doc/ilustra_verso_cin.png
// module id = IuZw
// module chunks = 1